import {StartTime} from "../services/TimesProvider";

export default class AdditionalBookingType {

    id: string
    name: string
    isValid: boolean
    startTime: StartTime
    duration: number
    selectable: boolean

    constructor (data: any) {
        this.id = data.id
        this.name = data.name
        this.isValid = !!data.valid
        this.startTime = data.startTime || null
        this.duration = data.duration || 0
        this.selectable = true
    }
}



// WEBPACK FOOTER //
// ./src/models/AdditionalBookingType.ts